import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import ZipcodeListComponent from "../components/zipcode/ZipcodeListComponent";
import ZipcodeFormComponent from "../components/zipcode/ZipcodeFormComponent";
import ZipcodeShowComponent from "../components/zipcode/ZipcodeShowComponent";

const ZipcodePage = (props) => {

  const {t, i18n} = props;

  useEffect(() => {
    document.title = t('zipcode') + ' - ' + process.env.REACT_APP_TITLE;
  }, []);

  return (
    <div className="ZipcodePage p-component p-m-lg-4">
      <div className={"p-p-3 p-p-lg-0"}>
        <Panel>
          <ZipcodeListComponent />
        </Panel>
        <Sidebar position="right" visible={window.App.state.sidebarZipcodeForm} closeOnEscape={true}
                 style={{width: '780px'}}
                 onHide={() => window.App.setState({
                   sidebarZipcodeForm: false,
                 })}>
          <ZipcodeFormComponent />
        </Sidebar>
        <Sidebar position="right" visible={window.App.state.sidebarZipcodeShow} closeOnEscape={true}
                 style={{width: '780px'}}
                 onHide={() => window.App.setState({
                   sidebarZipcodeShow: false,
                 })}>
          <ZipcodeShowComponent />
        </Sidebar>
      </div>
    </div>
  )
}
export default withTranslation('common')(ZipcodePage);
